/// <amd-module name="Feed/Connect/Protocols/NuGet" />
import { replaceRouteValues } from "VSS/Platform/Util/Url";

import { PackagingService } from "Feed/Core/PackagingService";
import { IUxFeedView } from "Feed/Core/UxFeedView";

import { PackagingProcotol } from "../Protocol";
import { PackagingTool, ToolId } from "../Tool";

import * as Res from "Feed/Connect/Resources";

class NuGetProtocol extends PackagingProcotol {
    constructor() {
        super("NuGet");
    }

    public readonly area = "nuget";

    public getFeedUrl(packagingService: PackagingService, feed: IUxFeedView) {
        // TODO: Move route resolution to endpoints within this object
        const path = replaceRouteValues("_packaging/{feedId}/{area}/v3/index.json", {
            feedId: feed.name,
            area: this.area
        });

        return packagingService.getUrl(feed.project, path);
    }
}

const NuGet = new NuGetProtocol();

class NuGetTool extends PackagingTool {
    constructor(
        id: ToolId,
        name: string,
        imageName: string,
        private toolLinkId: number,
        private toolLinkText: string = Res.CommandLineReference
    ) {
        super(id, name, NuGet, { src: `ms.feed/feed-connect/Content/${imageName}` });
    }

    public getToolLink = () => ({
        href: `https://go.microsoft.com/fwlink/?linkid=${this.toolLinkId}`,
        children: this.toolLinkText
    });
}

export const DotNet = new NuGetTool(ToolId.DotNet, "dotnet", "dot-net-core.svg", 2103873);
export const NuGetExe = new NuGetTool(ToolId.NuGet, "NuGet.exe", "nuget.svg", 2103785);
export const VisualStudio = new NuGetTool(
    ToolId.VisualStudio,
    "Visual Studio",
    "visual-studio-2019.svg",
    2103786,
    Res.LearnAboutRestore
);
